<template>
  <v-container class="pa-0">
    <v-toolbar style="z-index:1" color="black">
      <div>
        <img
          class="diageo"
          src="../img/logo.png"
          width="75"
          alt="Logo Diageo"
        />
      </div>
      <div>
        <v-btn icon @click="$router.go(-1)">
          <img
            class="btnBack"
            src="../img/right-arrow.png"
            width="25"
            alt="Botão voltar"
          />
        </v-btn>
      </div>
    </v-toolbar>
    <v-main>
      <carousel-novidades :novidades="novidades"></carousel-novidades>
    </v-main>
  </v-container>
</template>
<script>
import CarouselNovidades from '../components/CarouselNovidades.vue';
export default {
  name: "Novidades",
  components: { CarouselNovidades },
  data(){ 
    return { 
      loading: false,
      novidades: []
    }
  },
  created() {
    this.loading = true;
    fetch(this.$drink_uri + "/novidade/client",
    {headers: {
      'Authorization': `Bearer ${localStorage.tokenDrink}`
    },
      credentials: "include"})
      .then((response) => response.json())
      .then((data) => {
        this.novidades = data;
        this.loading = false;
        this.$forceUpdate();
      });
  }
};
</script>
